<div>
  <div class="flex flex-row justify-start items-center flex-1-0-auto">
    <div class="page-title">
      <h1>Global File Manager</h1>
    </div>
  </div>
</div>
